<template>
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M13.3822 3.85413C12.2662 3.85413 11.949 4.34912 11.949 5.44037V7.2415H14.9173L14.6248 10.1592H11.9484V19H8.39625V10.1586H6V7.24094H8.39738V5.49044C8.39738 2.54688 9.5775 1 12.8878 1C13.5982 1 14.4482 1.05625 14.9556 1.12712V3.8665" fill="#3C5A99"/>
</svg> 
</template>